module.exports = __webpack_public_path__ + "img/icon_t1_c.3fb41698.png";